
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["feather feather-bell-off",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","class":"feather feather-bell-off"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.56 2.9A7 7 0 0119 9v4m-2 4H2a3 3 0 003-3V9a7 7 0 01.78-3.22M13.73 21a2 2 0 01-3.46 0M1 1l22 22"}})])
          )
        }
      }
    